module.exports = __webpack_public_path__ + "static/mobile-home-demolition-single-b3ca8c719cecba34591e2808b7d20b01.jpg";